"use strict";

/**
 *  平台设置
 *  @module 环境属性
 */

import Vue from "@/main";
import * as mapWork from "../map.js";

// 默认数据
const form = {
  brightnessVal: 1.3, //环境亮度配置
  msaaSamples: 4, //反锯齿配置
  surfaceOpacity: 1, //地表不透明度
  layerOpacity: 1, //瓦片透明度
  layerBrightness: 1, //瓦片亮度
  layerContrast: 1, //瓦片对比度
  layerHue: 0, //瓦片色彩
  layerSaturation: 1, //瓦片饱和度
  layerGamma: 1, //瓦片伽马值
};

// 保存提交 (存储至localStorage)
const saveEnvironmentSettings = (data) => {
  localStorage.setItem("environmentSettings", JSON.stringify(data));
};

// 对外暴露基本属性 / 取消保存
const exposureEnvironmentSettings = () => {
  if (localStorage.getItem("environmentSettings")) {
    return JSON.parse(localStorage.getItem("environmentSettings"));
  } else {
    localStorage.setItem("environmentSettings", JSON.stringify(form));
    return JSON.parse(JSON.stringify(form));
  }
};

// 处理效果
const setEnvironmentEffect = (data, map = Vue.$GLOBAL.map) => {
  const {
    brightnessVal,
    msaaSamples,
    surfaceOpacity,
    layerOpacity,
    layerBrightness,
    layerContrast,
    layerHue,
    layerSaturation,
    layerGamma,
  } = data;
  console.log("setEnvironmentEffect", data, Vue.$GLOBAL);
  // 环境亮度开关
  Vue.$GLOBAL.brightnessEffect.enabled = true;
  // 环境亮度配置
  Vue.$GLOBAL.brightnessEffect.brightness = brightnessVal;
  if (Vue.$GLOBAL.mapClone) {
    Vue.$GLOBAL.mapClone.getTileLayers().forEach((item) => {
      item.brightness = Vue.$GLOBAL.brightnessEffect.brightness;
    });
  }
  // 反锯齿配置
  Vue.$GLOBAL.map.scene.msaaSamples = msaaSamples;
  if (Vue.$GLOBAL.mapClone) {
    Vue.$GLOBAL.mapClone.scene.msaaSamples = msaaSamples;
  }
  // 地表不透明度
  mapWork.adjustUndergroundAlpha(surfaceOpacity);
  // 瓦片透明度
  mapWork.adjustTileOpacity(layerOpacity);
  // 瓦片亮度
  mapWork.adjustTileBrightness(layerBrightness);
  // 瓦片对比度
  mapWork.adjustTileContrast(layerContrast);
  // 瓦片色彩
  mapWork.adjustTileHue(layerHue);
  // 瓦片饱和度
  mapWork.adjustTileSaturation(layerSaturation);
  // 瓦片伽马值
  mapWork.adjustTileGamma(layerGamma);
};

export {
  saveEnvironmentSettings,
  exposureEnvironmentSettings,
  setEnvironmentEffect,
};
